import { Injectable } from '@angular/core';
import {SaveUserConnection, UserConnection} from "../communication/models/UserConnection";
import {FirebaseApp} from "angularfire2";
import {UserServiceProvider} from "../user-service/user-service";
import {EventParticipant} from "../communication/models/EventParticipant";
import {SessionService} from "../session-service";
import {DataReference} from "../../shared/DataReference";
import * as firebase from "firebase";

/*
  Generated class for the ConnectionsProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ConnectionsProvider {

  constructor(private sessionService: SessionService,
              private firebase: FirebaseApp,
              private userService: UserServiceProvider) {
  }

  sendConnectionRequest(participant: EventParticipant) : Promise<void> {
    return new Promise<void>((resolve, reject) => {

      this.sessionService.userSession$
        .first()
        .withLatestFrom(this.sessionService.publicProfile$)
        .subscribe(([session, profile]) => {

          let data: {};
          let timestamp = firebase.database.ServerValue.TIMESTAMP;

          data = this._generateDataForConnectionRequest(session.userId, participant.id, timestamp);

          let serverProcessingRef = DataReference.getServerProcessingRequestSent(session.eventId);
          let requestId = this.firebase.database().ref(serverProcessingRef).push().key;
          data[`${serverProcessingRef}/${requestId}`] = {
            requester: session.userId,
            receiver: participant.id,
            senderName: profile.displayName,
            timestamp: timestamp
          };

          console.log(data);

          this.firebase.database().ref().update(data, err => {
            if (err) {
              console.error(err);
              reject('Error sending request');
            } else {
              resolve();
            }
          }).catch(err => {
            console.error(err.code);
            reject('Error sending request');
          });
        });
    });
  }

  acceptConnectionRequest(participantId: string) {
    return new Promise<void>((resolve, reject) => {

      this.sessionService.userSession$
        .filter(x => !!x)
        .first()
        .subscribe(session => {

          let connectionData = this._generateDataForConnectionUpdate(session.userId, participantId, UserConnection.CONNECTION_REQUEST_STATUS_OK);
          // remove the request as it is being fulfilled
          let requestData = this._generateDataForConnectionRequest(participantId, session.userId, null);

          let data = {};
          Object.assign(data, connectionData, requestData);
          console.log(data);

          this.firebase.database().ref().update(data, err => {
            if (err) {
              console.error(err);
              reject('Error sending request');
            } else {
              resolve();
            }
          }).catch(err => {
            console.error(err.code);
            reject('Error sending request');
          });
        });
    });
  }

  cancelConnectionRequest(participantId: string) : Promise<void> {
    return new Promise<void>((resolve, reject) => {
      let data = this._generateDataForConnectionRequest(this.sessionService.userId, participantId, null);
      console.log(data);

      this.firebase.database().ref().update(data, err => {
        if (err) {
          console.error(err);
          reject('Error sending request');
        } else {
          resolve();
        }
      }).catch(err => {
        console.error(err.code);
        reject('Error sending request');
      });
    });
  }

  // region Helper methods

  private _generateDataForConnectionUpdate(requesterId: string, receiverId: string, status: number) {
    let data: {[key:string]: SaveUserConnection} = {};

    let date = Date.now();

    data[DataReference.getConnectionForUserRef(requesterId, receiverId)] = {
      status: status,
      timestampAdded: date,
    };
    data[DataReference.getConnectionForUserRef(receiverId, requesterId)] = {
      status: status,
      timestampAdded: date
    };

    console.log(data);

    return data;
  }


  private _generateDataForConnectionRequest(requesterId: string, receiverId: string, timestamp: any): any {
    let data: any = {};

    data[`${DataReference.getConnectionRequestsSentForUser(requesterId)}/${receiverId}`] = timestamp;
    data[`${DataReference.getConnectionRequestsReceivedForUser(receiverId)}/${requesterId}`] = timestamp;

    console.log(data);

    return data;
  };

  // endregion

}



// WEBPACK FOOTER //
// ./src/providers/connections/connections-service.ts